////// Lib. //////
//////////////////

import gsap from "gsap";
import { Draggable } from "gsap/Draggable";
gsap.registerPlugin(Draggable);

///// Util. //////
//////////////////

/**
 * Fix element width to prevent reflow during animations
 * @param {HTMLElement} el - Element to fix width for
 * @returns {number} - The fixed width value
 */
function fixElWidth(el) {
  gsap.set(el, { width: el.getBoundingClientRect().width });
}

// Event hdls. ///
//////////////////

// ...

///// Assets /////
//////////////////

const msgs = {
  start: ["init. cards"],
  end: ["init. cards", "init. success"],
};

/// Init. def. ///
//////////////////

export default function init_cards() {
  //////////////////// Setup /////////////////////
  ////////////////////////////////////////////////

  const el_comp = this.element;
  const { cards } = this.ref;
  const { logs } = this.options;
  if (logs) console.log(msgs.start[0]);

  ///////////////// Cards init. //////////////////
  ////////////////////////////////////////////////

  const animDur_openCloseCard = 0.3; // ms

  cards.forEach((c) => {
    ///// Slight scale-up on hover /////
    ////////////////////////////////////

    c.addEventListener("mouseenter", () => {
      if (c.dataset.open === "true" || c.dataset.animating === "true") return;
      gsap.to(c, { scale: 1.05, duration: 0.3, ease: "power2.out" });
    });
    c.addEventListener("mouseleave", () => {
      if (c.dataset.open === "true" || c.dataset.animating === "true") return;
      gsap.to(c, { scale: 1, duration: 0.3, ease: "power2.out" });
    });

    ///////// Draggable init. //////////
    ////////////////////////////////////

    // const dragInst =
    Draggable.create(c, {
      type: "x,y",
      edgeResistance: 0.45,
      bounds: el_comp,
      onPress: function () {
        gsap.set(this.target, { cursor: "grabbing" });
      },
      onRelease: function () {
        gsap.set(this.target, { cursor: "grab" });
      },
    })[0];

    ///////// Open-btn. init. //////////
    ////////////////////////////////////

    // - Record + store original dimensions and position for later restoration
    // - Calc. scaled-up dimensions for opening anim.
    const cardRect = c.getBoundingClientRect();
    const { width: w_org, height: h_org } = cardRect;
    c.dataset.wOrg = w_org;
    c.dataset.hOrg = h_org;
    const w_new = w_org * 1.333;
    const h_new = h_org * 1.333;

    const wrpr_text = c.querySelector('[data-ref="wrpr_text"]');
    const wrpr_text_ext = c.querySelector('[data-ref="wrpr_text_ext"]');
    const btn_open = c.querySelector('[data-ref="btn_open"]');

    // Fix text wrpr. width to avoid reflow
    fixElWidth(wrpr_text);

    if (btn_open) {
      btn_open.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        c.dataset.animating = "true";

        const is_open = c.dataset.open === "true";
        if (!is_open) {
          // OPENING //
          btn_open.dataset.active = "true";

          // Disable other cards
          cards.filter((c_other) => c_other !== c).forEach((c_other) => (c_other.dataset.disabled = "true"));

          // Fix text wrpr. width to avoid reflow
          fixElWidth(wrpr_text);

          // Animate to open size
          gsap.to(c, {
            width: w_new,
            height: h_new,
            scale: 1,
            duration: animDur_openCloseCard,
            ease: "power2.out",
            onComplete: () => {
              // Mark as opened
              c.dataset.open = "true";
              c.dataset.animating = "false";

              // Fix ext. text wrpr. width to avoid reflow
              gsap.set(wrpr_text, { width: "auto" });
              fixElWidth(wrpr_text_ext);
            },
          });
        } else {
          // CLOSING //
          c.dataset.animating = "true";
          btn_open.dataset.active = "false";

          // Re-enable other cards
          cards.filter((c_other) => c_other !== c).forEach((c_other) => (c_other.dataset.disabled = "false"));

          // Get stored dimensions
          const w_org = parseFloat(c.dataset.wOrg);
          const h_org = parseFloat(c.dataset.hOrg);

          // Animate back to org. size
          gsap.to(c, {
            width: w_org,
            height: h_org,
            scale: 1,
            duration: animDur_openCloseCard,
            ease: "power2.inOut",
            onComplete: () => {
              c.dataset.open = "false";
              c.dataset.animating = "false";
            },
          });
        }
      });
    }
  });

  //// Conclude ////
  //////////////////

  if (logs) console.log(msgs.end[0], "→", msgs.end[1]);
}
